import gsap from 'gsap/all';
import React, { useRef } from 'react';
import { StyledFormWebinar } from './StyledFormWebinar';
import { useHistory } from 'react-router-dom';
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";
import { BaseUrl } from "../../config";

const FormWebinar = ({ title, paragraph }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const errorGeneral = useRef(null);

  const checkTerms = (e) => {
    e.currentTarget.classList.toggle('checked')
    var parent = e.currentTarget.parentNode;
    if(parent.classList.contains('error')) {
      var errorText = parent.querySelector('.error-text');
      errorText.innerText = "";
      parent.classList.remove('error')
      checkOtherErrors()
    }
  }
  const removeError = (e) => {
    var parent = e.currentTarget.parentNode.parentNode;
    var errorText = parent.querySelector('.error-text')
    
    if(parent.classList.contains('error')) {
      parent.classList.remove('error')
      errorText.innerText = ""

      checkOtherErrors()
    }
  }

  const checkOtherErrors = () => {
    let allWraps = document.querySelectorAll('.input--wrap')
    var i = 0;
    var errorLength = 0
    while( i < allWraps.length ) {
      if(allWraps[i].classList.contains('error')){
        errorLength += 1
      }
      i++
    }

    if(errorLength > 0 && !errorGeneral.current.classList.contains('show')) errorGeneral.current.classList.add('show')
    else if(errorLength === 0 && errorGeneral.current.classList.contains('show')) errorGeneral.current.classList.remove('show')
  }

  const checkInput = () => {

    let allFiled = document.querySelectorAll('.input--wrap-row input');
    let validArray = 0;
    let check = document.querySelector('.check--terms');
    let checkParent = check.parentNode;
    let checkError = checkParent.querySelector('.error-text');
    

    for(let i = 0; i < allFiled.length; i++) {
      let value = allFiled[i].value;
      let type = allFiled[i].id
      let parent = allFiled[i].parentNode.parentNode;
      let errorText = parent.querySelector('.error-text');

      if(type !== "--email"){
        if(value.length === 0 || value === ""){
          errorText.innerText = "Please fill in this field";
          parent.classList.add('error')
          errorGeneral.current.classList.add('show')
        }else{
          validArray += 1
        }
        
      }else {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(value)){
          errorText.innerText = "Please enter a valid e-mail";
          parent.classList.add('error')
          errorGeneral.current.classList.add('show')
        }else {
          validArray += 1
        }
      }
    }
    
    if(validArray === allFiled.length) {
      
      if(!check.classList.contains('checked')){
        checkParent.classList.add('error')
        checkError.innerText = "Please accept our terms of use in order to confirm your registration";
        errorGeneral.current.classList.add('show')
      }else{
        
        send()
      }
    }


  }

  const send = () => {
    var formData = new FormData();
    var name = document.getElementById('--name').value
    var email = document.getElementById('--email').value
    var company = document.getElementById('--company').value
    var role = document.getElementById('--role').value
    var country = document.getElementById('--country').value
    var subject = "Registration Webinar December 12th"

    formData.append('key', 'invrsion');
    formData.append('subject', subject);
    formData.append('name', name);
    formData.append('organization', company);
    formData.append('mail', email);
    formData.append('role', role);
    formData.append('country', country);
    
    fetch(`${BaseUrl}/webinar`, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if(response.status === 200) {
        
        dispatch(setLoader(true));
  
        setTimeout(() =>{ 
          document.body.scrollTop = 0;
          history.push('/3d-commerce-webinar/thank-you')
        }, 500);
        
      }
    })
    
  }

  return (
    <React.Fragment>
      {
       
        <StyledFormWebinar>
          <h4 className="md--title form-title">{title}</h4>
          <p className="preset-9 form-paragraph" dangerouslySetInnerHTML={{ __html: paragraph }}></p>
          <div className="form-wrap">

            <div className="input--row">
              <h6 className="md--title" >What is your full name?</h6>
              <div className="input--wrap">
                <div className="input--wrap-row">
                  <input type="text" id="--name" onFocus={removeError}/>
                </div>
                <div className="input--wrap-row error--message">
                  <p className="preset-11 error-text">&nbsp;</p>
                </div>
              </div>
            </div>

            <div className="input--row">
              <h6 className="md--title" >What is your email address?</h6>
              <div className="input--wrap">
                <div className="input--wrap-row">
                  <input type="text" id="--email" onFocus={removeError}/>
                </div>
                <div className="input--wrap-row error--message">
                  <p className="preset-11 error-text">&nbsp;</p>
                </div>
              </div>
            </div>

            <div className="input--row">
              <h6 className="md--title" >Which company are you working for?</h6>
              <div className="input--wrap">
                <div className="input--wrap-row">
                  <input type="text" id="--company" onFocus={removeError}/>
                </div>
                <div className="input--wrap-row error--message">
                  <p className="preset-11 error-text">&nbsp;</p>
                </div>
              </div>
            </div>

            <div className="input--row">
              <h6 className="md--title" >What is your job position?</h6>
              <div className="input--wrap">
                <div className="input--wrap-row">
                  <input type="text" id="--role" onFocus={removeError}/>
                </div>
                <div className="input--wrap-row error--message">
                  <p className="preset-11 error-text">&nbsp;</p>
                </div>
              </div>
            </div>

            <div className="input--row">
              <h6 className="md--title" >Which country are you from?</h6>
              <div className="input--wrap">
                <div className="input--wrap-row">
                  <input type="text" id="--country" onFocus={removeError}/>
                </div>
                <div className="input--wrap-row error--message">
                  <p className="preset-11 error-text">&nbsp;</p>
                </div>
              </div>
            </div>

            <div className="input--row terms--row">
              <div className="check--terms" onClick={checkTerms}>
                <img src={require('../../assets/check.svg')} />
              </div>
              <p className="preset-10" >By checking this box, you confirm that you read and are agreeing to our 
              <a href="https://www.iubenda.com/privacy-policy/25080573" className="iubenda-nostyle no-brand iubenda-embed iub-legal-only" title="terms of use "> terms of use </a>
                regarding the storage of the data submitted through this form</p>
              <div className="check-error error--message">
                <p className="preset-11 error-text">&nbsp;</p>
              </div>
            </div>

            <div className="cta--primary cursor-cta" onClick={()=> checkInput()}>
              <h6 className="md--title cursor-cta" style={{color: '#45B865'}} >Register</h6>
              <img className="next cursor-cta" src="/cta-arrow-next-green.svg" />
            </div>
            <p ref={errorGeneral} className="preset-11 error-text error-general">All fields are required, all the errors above must be corrected before continuing</p>

          </div>
        </StyledFormWebinar>
          
      }
    </React.Fragment>
  );
};


export default FormWebinar;
